var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedLocation.teaser
    ? _c("div", { staticClass: "teaser-promo-block" }, [
        _c("div", { staticClass: "teaser-promo-block-container" }, [
          _vm.selectedLocation.teaser.imageUrl
            ? _c("div", { staticClass: "teaser-promo-block-image" }, [
                _c("img", {
                  attrs: {
                    src: _vm.selectedLocation.teaser.imageUrl,
                    alt: _vm.selectedLocation.teaser.imageAltText || ""
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "teaser-promo-block-info" }, [
            _c("h5", [_vm._v(_vm._s(_vm.selectedLocation.teaser.title))]),
            _vm._v(" "),
            _c("div", {
              staticClass: "heading",
              domProps: {
                innerHTML: _vm._s(_vm.selectedLocation.teaser.content)
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.onPromoBlockCTAClick }
              },
              [_vm._v(_vm._s(_vm.selectedLocation.teaser.ctaText))]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }